import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import { Grid, Typography, IconButton } from '@mui/material';
import { CategoryDropdown } from './order-navbar';
import CartDropdown from '../../../../layouts/dashboard/navbar/CartDropdown';
import { useSelector } from '../../../../redux/store';
import Iconify from '../../../../reusable-components/iconify';

CategoryViewHeader.propTypes = {
  view: PropTypes.string,
  setView: PropTypes.func,
};

export default function CategoryViewHeader({ view, setView }) {
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get('categoryId') || null;
  const category = searchParams.get('category') || null;

  const {
    data: { facilityName, categories = [] },
  } = useSelector((state) => state.orderSheet);

  return (
    <>
      <Grid container direction="row" sx={{ ml: 7.5 }} justifyContent="space-between" alignItems="flex-end">
        <Grid item>
          <Grid container direction="row" justifyContent="flex-start" alignItems="center">
            <Grid item>
              <Typography variant="subtitle1" color="primary">
                {facilityName}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="subtitle1" color="primary" sx={{ ml: 1 }}>
                |
              </Typography>
            </Grid>
            <Grid item>
              <CategoryDropdown categories={categories} id={categoryId} category={category} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="row" justifyContent="flex-end" alignItems="center">
            <Grid item>
              <IconButton onClick={() => setView('grid')} color={view === 'grid' ? 'primary' : 'default'}>
                <Iconify icon="garden:grid-3x3-fill-16" />
              </IconButton>
            </Grid>
            <Grid item sx={{ mr: 1 }}>
              <IconButton onClick={() => setView('list')} color={view === 'list' ? 'primary' : 'default'}>
                <Iconify icon="fa7-solid:list-ul" />
              </IconButton>
            </Grid>
            <Grid item sx={{ mr: 1 }}>
              <CartDropdown />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
